import { useState } from "react";
import { getMagentoImage, mapSizeLabel } from "../utils";

function ProductSelector({ products, onSelect }) {

  const [selectedSizes, setSelectedSizes] = useState({});

  if (!products || !products.length) {
    return <p>No products available</p>;
  }

  const getChildBySize = (product, selectedSize) => {
    const children = product.children || [];

    return children.find((child) =>
      child.custom_attributes?.some(
        (attr) =>
          attr.attribute_code === "fashion_size" &&
          attr.value === String(selectedSize)
      )
    );
  };

  const handleSizeChange = (productId, value) => {

    setSelectedSizes((prev) => ({
      ...prev,
      [productId]: value
    }));

  };

  return (
    <div className="product-selector">
      <h2 className="products-title">Select Your Jacket</h2>

      <div className="product-instructions">
        <p className="product-instructions-title">How it works</p>

        <ol>
          <li>Choose your jacket style and size.</li>
          <li>Enter your name for the personalization (optional).</li>
          <li>Confirm the spelling is correct.</li>
          <li>Click Continue to Checkout.</li>
          <li>Enter your shipping details.</li>
          <li>Click Submit Order.</li>
        </ol>
      </div>

      <div className="products">

        {products.map((product) => {

          const image =
            product?.media_gallery_entries?.[0]?.file;

          const sizes =
            product?.extension_attributes
              ?.configurable_product_options?.[0]
              ?.values || [];

          const selectedSize = selectedSizes[product.id] || "";

          const child = selectedSize
            ? getChildBySize(product, selectedSize)
            : null;
          const option = child?.options?.find(
            (opt) => opt.title === "Personalization"
          );
          
          const optionId = option?.option_id;
          const hasPersonalization = Boolean(optionId);

          return (
            <div key={product.id} className="product-card">

              <img
                src={getMagentoImage(image)}
                alt={product.name}
              />

              <p>{product.name}</p>

              <select
                value={selectedSize}
                onChange={(e) =>
                  handleSizeChange(product.id, e.target.value)
                }
              >
                <option value="">Select Size</option>

                {sizes.map((size) => (
                  <option
                    key={size.value_index}
                    value={size.value_index}
                  >
                    {mapSizeLabel(size.value_index)}
                  </option>
                ))}
              </select>

              <button
                disabled={!selectedSize || !child || !hasPersonalization}
                onClick={() => {
                  if (!child) return;
                  const sizeOptionId =
                    product.extension_attributes
                      ?.configurable_product_options?.[0]
                      ?.attribute_id;

                  onSelect({
                    product,
                    sku: child.sku,
                    optionId,
                    selectedSize,
                    sizeOptionId
                  });
                }}
              >
                Add to Cart
              </button>

              {selectedSize && child && !hasPersonalization && (
                <span style={{ color: "red" }}>
                  Product SKU without personalization field
                </span>
              )}

            </div>
          );

        })}

      </div>

    </div>
  );
}

export default ProductSelector;
